import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RequestTaskService {

  constructor(private httpClinetService: HttpClientService) { }

  async getAllRequestTask(page, size, search, status, date) {
    const observable: Observable<any> = this.httpClinetService.get({
      controller: ControllerType.RequestTask,
      queryString: `Page=${page}&Size=${size}&search=${search}&status=${status}&filterDate=${date}`
    });
    return await firstValueFrom(observable);
  }

  async getAllRequestTaskCompaines(page, size, companyId) {
    const observable: Observable<any> = this.httpClinetService.get({
      controller: ControllerType.RequestTask,
      action: "GetAllCompaniesRequestTasks",
      queryString: `Page=${page}&Size=${size}&CompanyId=${companyId}`
    });
    return await firstValueFrom(observable);
  }

  async createRequestTask(title, companyId: number, description?: string, startDate?: Date, companyPersonId?: number, priority?: number, personId?: number, offerId?: number) {
    const observable: Observable<any> = this.httpClinetService.post({
      controller: ControllerType.RequestTask
    }, {
      title: title,
      description: description,
      startDate: startDate,
      companyId: companyId,
      companyPersonId: companyPersonId,
      kindId: null,
      priority: priority,
      status: 1,
      personId: personId,
      offerId: offerId
    });
    return await firstValueFrom(observable);
  }

  async updateRequestTask(id: number, title: number, companyId: number, description?: string, startDate?: Date, endDate?: Date, companyPersonId?: number, priority?: number, personId?: number, status?: number) {
    const observable: Observable<any> = this.httpClinetService.put({
      controller: ControllerType.RequestTask
    }, {
      id: id,
      title: title,
      description: description,
      startDate: startDate,
      endDate: endDate,
      companyId: companyId,
      companyPersonId: companyPersonId,
      kindId: null,
      priority: priority,
      status: status,
      personId: personId
    });
    return await firstValueFrom(observable);
  }

  async getByIdRequestTask(id) {
    const observable: Observable<any> = this.httpClinetService.get({
      controller: ControllerType.RequestTask
    }, id);
    return await firstValueFrom(observable);
  }

  async getRequestFiles(page, size, id) {
    const observable: Observable<any> = this.httpClinetService.get({
      controller: ControllerType.RequestTask,
      action: "GetAllRequestFile",
      queryString: `Page=${page}&Size=${size}&id=${id}`
    });
    return await firstValueFrom(observable);
  }

  async createRequestFile(files: File[], id) {
    const formData = new FormData();
    formData.append('RequestTaskId', id);
    if (files && files.length) {
      files.forEach((file, index) => {
        formData.append('FormFiles', file, file.name || `file${index}`);
      });
    }
    const observable: Observable<any> = this.httpClinetService.post({
      controller: ControllerType.RequestTask,
      action: "CreateRequestTaskFile"
    }, formData);
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
